import request from '@/router/axios';

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'false' ? '/sys' : '/sys'
//发送邮件
export function sentEmail(obj) {
  return request({
    url: urlPrefix + '/taxManage/sentEmail',
    method: 'post',
    data: obj
  });
}
//邮件确认
export function confirmEmail(obj) {
  return request({
    url: urlPrefix + '/taxManage/confirmEmail',
    method: 'post',
    params: obj
  });
}
//导出
export function exportExcle(id) {
  return request({
    url: urlPrefix + '/taxManage/exportExcle',
    method: 'get',
    responseType: 'arraybuffer',
    params:{
        batchId: id
    }
  });
}

